import React from 'react'
import Dialog from 'material-ui/Dialog'
import { ImporListModal, InviteAllModal, InviteModal, PreviewModal, RemoveAllModal } from './Modals'

const modalType = Modal => {
  const ModalType = props => (
    <Dialog
      contentStyle={{
        width: props.purpose === 'invite' ? 442 : 535
      }}
      bodyStyle={{
        padding: props.purpose === 'import' ? 0 : 24
      }}
      open={props.open}
    >
      {props.purpose === 'invite' ? (
        <Modal>
          <InviteModal
            selectConferenceId={props.selectConferenceId}
            addParticipant={props.addParticipant}
            handleClose={props.handleClose}
            snackbarOpen={props.snackbarOpen}
          />
        </Modal>
      ) : props.purpose === 'import' ? (
        <Modal>
          <ImporListModal
            handleClose={props.handleClose}
            selectConferenceId={props.selectConferenceId}
            isFetchingList={props.isFetchingList}
            importParticipants={props.importParticipants}
            contacts={props.contacts}
            snackbarOpen={props.snackbarOpen}
          />
        </Modal>
      ) : props.purpose === 'inviteAll' ? (
        <Modal>
          <InviteAllModal
            totalParticipants={props.totalParticipants}
            actionForAll={props.actionForAll}
            handleClose={props.handleClose}
          />
        </Modal>
      ) : props.purpose === 'preview' ? (
        <Modal>
          <PreviewModal
            conferenceDetails={props.conferenceDetails}
            selectConferenceId={props.selectConferenceId}
            handleClose={props.handleClose}
          />
        </Modal>
      ) : (
        <Modal>
          <RemoveAllModal
            totalParticipants={props.totalParticipants}
            handleClose={props.handleClose}
            actionForAll={props.actionForAll}
          />
        </Modal>
      )}
    </Dialog>
  )
  return ModalType
}

export default modalType



// WEBPACK FOOTER //
// ./src/components/Seminars/SeminarActions/ModalHOC.js